import PaperContactChips from 'ember-paper/components/paper-contact-chips/component';
import { tagName } from '@ember-decorators/component';

@tagName('')
class SingleContactChip extends PaperContactChips {}

export default SingleContactChip;
